import {useUser} from "../contexts/UserContext";
import {useTranslation} from "react-i18next";
import "../styleSheets/welcomeHeader.css"

type WelcomeHeaderProps = {
    variant?: "dashboard" | "panel";
    id?: string;
};
function WelcomeHeader({variant = "dashboard", id}: WelcomeHeaderProps){
    const {t} = useTranslation("common");
    const {firstName, lastName, nickname } = useUser();
    let greetingText;
    let greetingName;
    if (variant === "dashboard"){
        const displayName = nickname ?? firstName ?? "";
        greetingName = displayName
            ? `${t("common.welcomeBack")} ${displayName}!`
            : `${t("common.welcomeBack")}!`;
        greetingText = t("common.greetingText");
    } else if (variant === "panel"){
        greetingName = [firstName, lastName].filter(Boolean).join(" ");
        greetingText = "";
    }
    const HeadingTag = variant === "dashboard" ? "h1" : "h2";
    return (
        <div className="section-welcome-back">
            <HeadingTag id={id} className="welcome-back-user">{greetingName}</HeadingTag>
            <div className="welcome-back-sub-text">{greetingText}</div>
        </div>
    )
}
export default WelcomeHeader;
